<style lang="scss" scoped>
  @import '../../sass/variables';

.the-sidebar-container {
  background: $salesflow-sidebar-gradient;
  background-attachment: fixed;
  position: relative;
}

.the-sidebar-container::after {
    content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  right: -4px;
  width: 8px;
  z-index: 1;
  background: transparent;
}

.fa.fa-chevron-up {
  font-size: 6px;
}

.the-sidebar {
  width: $the-sidebar-width;
  flex: 0 0 $the-sidebar-width;
  transition: all 250ms ease-in-out;
  position: sticky;
  z-index: 10;

  .sidebar-container {
    position: fixed;
  }

  .logo {
    position: relative;
    width: $the-sidebar-width;
    padding: $the-sidebar-logo-padding;
    transition: width 600ms ease-in-out;
  }

  .btn-toggle-collapse {
    width: 28px;
    height: 28px;
    line-height: 28px;
    text-align: center;
    color: $gray-dark;
    background-color: $white-gray;
    box-shadow: 0 5px 10px rgba(103, 70, 162, 0.59);
    border-radius: 100%;
    position: absolute;
    top: 35px;
    left: $the-sidebar-btn-toggle-collapse-left;
    cursor: pointer;
    transition: all 250ms ease-in-out;
    transform: rotate(0deg);
    z-index: 2;

    .fa.fa-chevron-left {
      margin-right: 3px;
      font-size: 8px;
      color: $salesflow-primary;
    }
  }

  .sidebar-nav {
    position: relative;
    transition: width 600ms;
    width: $the-sidebar-width;

    .nav-featured-area {
      background-color: $salesflow-primary;
      width: $the-sidebar-width;
      padding: 0; // $the-sidebar-nav-padding;
      transition: max-height 250ms ease-in-out, width 250ms ease-in-out;

      .nav-title {
        padding: 8px 0px 16px 30px;
        background-color: $salesflow-purple-medium;
      }

      .nav-item {
        padding: 2px 0px 2px 30px;
        background-color: $salesflow-purple-medium;
      }

      .nav-item:first-child {
        margin-top: 12px;
      }

      .nav-item:last-child {
        padding-bottom: 12px;
      }

      > .featured-name {
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: $white-gray;
        font-family: Montserrat;
        font-size: 0.75rem;
        font-weight: 700;
        letter-spacing: 0.24px;
        line-height: 25px;
        padding: 12px 15px 12px 30px;
        position: relative;
        white-space: nowrap;
        overflow: visible;

        > i {
          color: $gray-light;
          transform: scale(1.8) rotate(0deg);
          transition: ease-in-out 250ms;
          cursor: pointer;
        }
      }

      > .nav {
        padding: 0;
      }

      &.collapsed {
        max-height: 85px;

        > .featured-name {
          > i {
            transform: scale(1.8) rotate(180deg);
          }
        }
      }
    }

    .nav {
      width: $the-sidebar-width;
      // height: 100%;
      padding: $the-sidebar-nav-padding;
      border-bottom: 1px solid $salesflow-primary;

      > .nav-featured-name,
      > .nav-title,
      > .nav-item {
        display: block;
        width: 100%;
      }

      .nav-link:hover {
        color: $salesflow-secondary-hover !important;
      }

      > .nav-title {
        color: $salesflow-font-purple-light;
        font-family: Montserrat;
        font-size: 0.625rem;
        font-weight: 500;
        letter-spacing: 0.2px;
        line-height: 25px;
        text-transform: uppercase;
        height: 25px;
      }

      > .nav-item {
        > .nav-link {
          color: $white-gray;
          font-family: Montserrat;
          font-size: 0.75rem;
          font-weight: 500;
          letter-spacing: 0.24px;
          line-height: 25px;
          padding: 0;

          &:hover,
          &.active,
          &.active:hover {
            color: $salesflow-secondary-hover;
          }

          &.active {
            color: $salesflow-secondary;
            font-weight: 600;
          }

          &.locked {
            color: $gray-light;
          }
        }
      }

      &.no-bb {
        border-bottom: 0;
      }
    }
  }

  &.collapsed {
    width: $the-sidebar-collapsed-width;
    flex: 0 0 $the-sidebar-collapsed-width;
    // transform: translate(0, 0);

    .logo {
      width: $the-sidebar-collapsed-width;
    }

    .btn-toggle-collapse {
      left: $the-sidebar-btn-toggle-collapse-collapsed-left;
      transform: rotate(180deg);
    }

    .sidebar-nav {
      width: $the-sidebar-collapsed-width;
      height: 100vh;

      .nav {
        width: $the-sidebar-collapsed-width;
      }

      .nav-icon {
        width: $the-sidebar-collapsed-width;
        padding: $the-sidebar-nav-icon-padding;
        text-align: center;

        .icon {
          path {
            fill: $white-gray;
          }
        }

        &:hover,
        &.active {
          .icon {
            path {
              fill: $green;
            }
          }
        }
      }
    }
  }

  ::v-deep .multiselect {
    min-height: 0px;
  }

  ::v-deep .multiselect__select:before {
    border-style: none;
  }

  ::v-depp .multiselect__select {
    display: none !important;
  }

  ::v-deep .multiselect__tags {
    min-height: 0px;
    height: auto;
    padding: 0px;
    border: none;
    background: transparent;
  }

  ::v-deep .multiselect__single {
    padding-left: 0px;
    margin-bottom: 0px;
    background: transparent;
    color: $white-gray;
    font-family: $font-family-sans-serif;
    font-size: 0.75rem;
    font-weight: 700;
    letter-spacing: 0.24px;
    line-height: 25px;
  }

  ::v-deep .multiselect__content-wrapper {
    overflow: auto;
    width: auto;
    font-size: 0.75rem;
    font-weight: 400;
    letter-spacing: 0.24px;
    line-height: 25px;
    box-shadow: 0 10px 20px rgba(103, 70, 162, 0.18);
    border-radius: 3px;
    background-color: $white-gray-2;
    color: $gray-dark;
    font-family: "Montserrat";
    font-weight: 500;
    letter-spacing: -0.18px;
    margin-top: 12px;

    .multiselect__option--highlight {
      color: $gray-dark;
      background: $gray-white-2;
    }

    &::-webkit-scrollbar {
      width: 4px;
      border-radius: 30px;
    }

    &::-webkit-scrollbar-thumb {
      background: $gray-soft-2;
      border-radius: 30px;
    }

    &:before {
      content: "";
      display: block;
      position: fixed;
      width: 0;
      height: 0;
      border-left: 25px solid transparent;
      border-right: 25px solid transparent;
      border-bottom: 10px solid $white-gray-2;
      margin-top: -6px;
      margin-left: 5px;
    }
  }

  ::v-deep .multiselect__input {
    background-color: transparent;
    color: $white-gray;
    font-family: $font-family-sans-serif;
    font-size: 0.75rem;
    font-weight: 700;
    letter-spacing: 0.24px;
  }

  ::v-deep .multiselect__single {
    padding: 0;
  }

  ::v-deep .multiselect__input::placeholder {
    color: $gray-light-2;
    font-size: 0.75rem;
    font-weight: 400;
    letter-spacing: 0.24px;
  }
}
</style>

<template>
  <div
    class="the-sidebar-container"
    @mouseleave="mouseLeftSidebar()"
  >
    <div
    class="the-sidebar"
      :class="[sideBarClass]"
    @keyup="handleKey"
  >
    <div
      class="sidebar-container"
      :style="{ position: sidebarPosition }"
    >
      <a
        class="btn-toggle-collapse"
        @click="toggleIsCollapsed"
      ><i class="fa fa-chevron-left" /></a>
        <div
          class="content"
          :style="{ overflow: multiselectOpened ? 'visible' : 'hidden' }"
        >
          <div class="logo">
            <TheLogo :collapsed="isCollapsed" />
          </div>
          <nav
            class="sidebar-nav"
            @mouseover="toggleIsCollapsed(true)"
            v-if="isCollapsed"
          >
          <div
            class="nav-icon"
            :class="{active: isIconActive('conta')}"
          >
              <a href="#!">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 5.25C9.72188 5.25 7.875 7.09688 7.875 9.375C7.875 11.6531 9.72188 13.5 12 13.5C14.2781 13.5 16.125 11.6531 16.125 9.375C16.125 7.09688 14.2781 5.25 12 5.25ZM12 11.25C10.9659 11.25 10.125 10.4086 10.125 9.375C10.125 8.33906 10.9641 7.5 12 7.5C13.0359 7.5 13.875 8.34094 13.875 9.375C13.875 10.4109 13.0359 11.25 12 11.25ZM12 0C5.37188 0 0 5.37188 0 12C0 18.6281 5.37188 24 12 24C18.6281 24 24 18.6281 24 12C24 5.37188 18.6281 0 12 0ZM12 21.75C9.80953 21.75 7.7925 21.015 6.16406 19.7911C6.975 18.2344 8.55 17.25 10.3219 17.25H13.6823C15.4519 17.25 17.025 18.2348 17.8392 19.7911C16.2094 21.0141 14.1891 21.75 12 21.75ZM19.5094 18.2109C18.2438 16.2328 16.0875 15 13.6781 15H10.3219C7.91437 15 5.75859 16.2305 4.49063 18.21C3.09188 16.5234 2.25 14.3578 2.25 12C2.25 6.62344 6.62391 2.25 12 2.25C17.3761 2.25 21.75 6.62391 21.75 12C21.75 14.3578 20.9062 16.5234 19.5094 18.2109Z" fill="white"/>
                </svg>
              </a>
            </div>
          <div
            class="nav-icon"
            :class="{active: isIconActive('início')}"
          >
              <a href="#!">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1.5 3.75C1.5 3.15326 1.73705 2.58097 2.15901 2.15901C2.58097 1.73705 3.15326 1.5 3.75 1.5H8.25C8.84674 1.5 9.41903 1.73705 9.84099 2.15901C10.2629 2.58097 10.5 3.15326 10.5 3.75V8.25C10.5 8.84674 10.2629 9.41903 9.84099 9.84099C9.41903 10.2629 8.84674 10.5 8.25 10.5H3.75C3.15326 10.5 2.58097 10.2629 2.15901 9.84099C1.73705 9.41903 1.5 8.84674 1.5 8.25V3.75ZM3.75 3C3.55109 3 3.36032 3.07902 3.21967 3.21967C3.07902 3.36032 3 3.55109 3 3.75V8.25C3 8.44891 3.07902 8.63968 3.21967 8.78033C3.36032 8.92098 3.55109 9 3.75 9H8.25C8.44891 9 8.63968 8.92098 8.78033 8.78033C8.92098 8.63968 9 8.44891 9 8.25V3.75C9 3.55109 8.92098 3.36032 8.78033 3.21967C8.63968 3.07902 8.44891 3 8.25 3H3.75ZM13.5 3.75C13.5 3.15326 13.7371 2.58097 14.159 2.15901C14.581 1.73705 15.1533 1.5 15.75 1.5H20.25C20.8467 1.5 21.419 1.73705 21.841 2.15901C22.2629 2.58097 22.5 3.15326 22.5 3.75V8.25C22.5 8.84674 22.2629 9.41903 21.841 9.84099C21.419 10.2629 20.8467 10.5 20.25 10.5H15.75C15.1533 10.5 14.581 10.2629 14.159 9.84099C13.7371 9.41903 13.5 8.84674 13.5 8.25V3.75ZM15.75 3C15.5511 3 15.3603 3.07902 15.2197 3.21967C15.079 3.36032 15 3.55109 15 3.75V8.25C15 8.44891 15.079 8.63968 15.2197 8.78033C15.3603 8.92098 15.5511 9 15.75 9H20.25C20.4489 9 20.6397 8.92098 20.7803 8.78033C20.921 8.63968 21 8.44891 21 8.25V3.75C21 3.55109 20.921 3.36032 20.7803 3.21967C20.6397 3.07902 20.4489 3 20.25 3H15.75ZM1.5 15.75C1.5 15.1533 1.73705 14.581 2.15901 14.159C2.58097 13.7371 3.15326 13.5 3.75 13.5H8.25C8.84674 13.5 9.41903 13.7371 9.84099 14.159C10.2629 14.581 10.5 15.1533 10.5 15.75V20.25C10.5 20.8467 10.2629 21.419 9.84099 21.841C9.41903 22.2629 8.84674 22.5 8.25 22.5H3.75C3.15326 22.5 2.58097 22.2629 2.15901 21.841C1.73705 21.419 1.5 20.8467 1.5 20.25V15.75ZM3.75 15C3.55109 15 3.36032 15.079 3.21967 15.2197C3.07902 15.3603 3 15.5511 3 15.75V20.25C3 20.4489 3.07902 20.6397 3.21967 20.7803C3.36032 20.921 3.55109 21 3.75 21H8.25C8.44891 21 8.63968 20.921 8.78033 20.7803C8.92098 20.6397 9 20.4489 9 20.25V15.75C9 15.5511 8.92098 15.3603 8.78033 15.2197C8.63968 15.079 8.44891 15 8.25 15H3.75ZM13.5 15.75C13.5 15.1533 13.7371 14.581 14.159 14.159C14.581 13.7371 15.1533 13.5 15.75 13.5H20.25C20.8467 13.5 21.419 13.7371 21.841 14.159C22.2629 14.581 22.5 15.1533 22.5 15.75V20.25C22.5 20.8467 22.2629 21.419 21.841 21.841C21.419 22.2629 20.8467 22.5 20.25 22.5H15.75C15.1533 22.5 14.581 22.2629 14.159 21.841C13.7371 21.419 13.5 20.8467 13.5 20.25V15.75ZM15.75 15C15.5511 15 15.3603 15.079 15.2197 15.2197C15.079 15.3603 15 15.5511 15 15.75V20.25C15 20.4489 15.079 20.6397 15.2197 20.7803C15.3603 20.921 15.5511 21 15.75 21H20.25C20.4489 21 20.6397 20.921 20.7803 20.7803C20.921 20.6397 21 20.4489 21 20.25V15.75C21 15.5511 20.921 15.3603 20.7803 15.2197C20.6397 15.079 20.4489 15 20.25 15H15.75Z" fill="white"/>
                </svg>
              </a>
            </div>
          <div
            class="nav-icon"
            :class="{active: isIconActive('vendas')}"
          >
              <a href="#!">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M22.5 21C22.5 21 24 21 24 19.5C24 18 22.5 13.5 16.5 13.5C10.5 13.5 9 18 9 19.5C9 21 10.5 21 10.5 21H22.5ZM10.533 19.5C10.5219 19.4985 10.5109 19.4965 10.5 19.494C10.5015 19.098 10.7505 17.949 11.64 16.914C12.468 15.9435 13.923 15 16.5 15C19.0755 15 20.5305 15.945 21.36 16.914C22.2495 17.949 22.497 19.0995 22.5 19.494L22.488 19.497C22.481 19.4982 22.474 19.4992 22.467 19.5H10.533ZM16.5 10.5C17.2956 10.5 18.0587 10.1839 18.6213 9.62132C19.1839 9.05871 19.5 8.29565 19.5 7.5C19.5 6.70435 19.1839 5.94129 18.6213 5.37868C18.0587 4.81607 17.2956 4.5 16.5 4.5C15.7044 4.5 14.9413 4.81607 14.3787 5.37868C13.8161 5.94129 13.5 6.70435 13.5 7.5C13.5 8.29565 13.8161 9.05871 14.3787 9.62132C14.9413 10.1839 15.7044 10.5 16.5 10.5ZM21 7.5C21 8.09095 20.8836 8.67611 20.6575 9.22208C20.4313 9.76804 20.0998 10.2641 19.682 10.682C19.2641 11.0998 18.768 11.4313 18.2221 11.6575C17.6761 11.8836 17.0909 12 16.5 12C15.9091 12 15.3239 11.8836 14.7779 11.6575C14.232 11.4313 13.7359 11.0998 13.318 10.682C12.9002 10.2641 12.5687 9.76804 12.3425 9.22208C12.1164 8.67611 12 8.09095 12 7.5C12 6.30653 12.4741 5.16193 13.318 4.31802C14.1619 3.47411 15.3065 3 16.5 3C17.6935 3 18.8381 3.47411 19.682 4.31802C20.5259 5.16193 21 6.30653 21 7.5ZM10.404 13.92C9.80397 13.7311 9.18545 13.6069 8.559 13.5495C8.207 13.516 7.85359 13.4995 7.5 13.5C1.5 13.5 0 18 0 19.5C0 20.5005 0.4995 21 1.5 21H7.824C7.60163 20.5317 7.49074 20.0183 7.5 19.5C7.5 17.985 8.0655 16.437 9.135 15.144C9.4995 14.703 9.924 14.2905 10.404 13.92ZM7.38 15C6.49223 16.3339 6.01266 17.8977 6 19.5H1.5C1.5 19.11 1.746 17.955 2.64 16.914C3.4575 15.96 4.878 15.03 7.38 15.0015V15ZM2.25 8.25C2.25 7.05653 2.72411 5.91193 3.56802 5.06802C4.41193 4.22411 5.55653 3.75 6.75 3.75C7.94347 3.75 9.08807 4.22411 9.93198 5.06802C10.7759 5.91193 11.25 7.05653 11.25 8.25C11.25 9.44347 10.7759 10.5881 9.93198 11.432C9.08807 12.2759 7.94347 12.75 6.75 12.75C5.55653 12.75 4.41193 12.2759 3.56802 11.432C2.72411 10.5881 2.25 9.44347 2.25 8.25ZM6.75 5.25C5.95435 5.25 5.19129 5.56607 4.62868 6.12868C4.06607 6.69129 3.75 7.45435 3.75 8.25C3.75 9.04565 4.06607 9.80871 4.62868 10.3713C5.19129 10.9339 5.95435 11.25 6.75 11.25C7.54565 11.25 8.30871 10.9339 8.87132 10.3713C9.43393 9.80871 9.75 9.04565 9.75 8.25C9.75 7.45435 9.43393 6.69129 8.87132 6.12868C8.30871 5.56607 7.54565 5.25 6.75 5.25Z" fill="white"/>
                </svg>
              </a>
            </div>
          <div
            class="nav-icon"
            :class="{active: isIconActive('marketing')}"
          >
              <a href="#!">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_554_175489)">
                <path d="M19.5 3.75C19.5 3.15326 19.7371 2.58097 20.159 2.15901C20.581 1.73705 21.1533 1.5 21.75 1.5C22.3467 1.5 22.919 1.73705 23.341 2.15901C23.7629 2.58097 24 3.15326 24 3.75V20.25C24 20.8467 23.7629 21.419 23.341 21.841C22.919 22.2629 22.3467 22.5 21.75 22.5C21.1533 22.5 20.581 22.2629 20.159 21.841C19.7371 21.419 19.5 20.8467 19.5 20.25V19.929C16.257 18.0675 12.765 17.1645 9.132 16.8045L9.7395 20.8725C9.7803 21.0892 9.77281 21.3123 9.71756 21.5258C9.66232 21.7393 9.56068 21.938 9.41988 22.1077C9.27908 22.2774 9.10259 22.414 8.90297 22.5078C8.70336 22.6015 8.48553 22.6501 8.265 22.65H7.443C7.15143 22.65 6.86619 22.565 6.62217 22.4054C6.37815 22.2458 6.18592 22.0186 6.069 21.7515L3.294 16.5165C3.193 16.5149 3.092 16.5134 2.991 16.512C2.19655 16.5041 1.43718 16.1836 0.877358 15.6198C0.317536 15.0561 0.00232777 14.2945 0 13.5L0 10.5C0.00267717 9.70544 0.317355 8.94372 0.876245 8.37894C1.43513 7.81416 2.19351 7.49151 2.988 7.4805C4.23004 7.46366 5.47171 7.42615 6.7125 7.368C11.277 7.137 15.9345 6.0945 19.5 4.0695V3.75ZM21 3.75V20.25C21 20.4489 21.079 20.6397 21.2197 20.7803C21.3603 20.921 21.5511 21 21.75 21C21.9489 21 22.1397 20.921 22.2803 20.7803C22.421 20.6397 22.5 20.4489 22.5 20.25V3.75C22.5 3.55109 22.421 3.36032 22.2803 3.21967C22.1397 3.07902 21.9489 3 21.75 3C21.5511 3 21.3603 3.07902 21.2197 3.21967C21.079 3.36032 21 3.55109 21 3.75ZM19.5 5.775C15.984 7.5825 11.6865 8.538 7.5 8.8245V15.174C7.77 15.189 8.0385 15.207 8.3055 15.228C12.1575 15.5115 15.945 16.344 19.5 18.2175V5.775ZM6 15.0975V8.9025C5.0043 8.93894 4.00824 8.96494 3.012 8.9805C2.61116 8.98521 2.22817 9.14704 1.94542 9.4312C1.66266 9.71536 1.50272 10.0991 1.5 10.5V13.5C1.5 14.325 2.172 15.003 3.009 15.0135C4.00639 15.0251 5.00353 15.0531 6 15.0975ZM5.0145 16.56L7.428 21.1155L7.443 21.1515H8.265L8.262 21.1305L7.5975 16.6815C6.73705 16.6296 5.87599 16.5886 5.0145 16.5585V16.56Z" fill="white"/>
                  </g>
                  <defs>
                    <clipPath id="clip0_554_175489">
                <rect width="24" height="24" fill="white"/>
                    </clipPath>
                  </defs>
                </svg>
              </a>
            </div>
          <div
            class="nav-icon"
            :class="{active: isIconActive('análises')}"
          >
              <a href="#!">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16.281 11.781C16.4218 11.6402 16.5009 11.4492 16.5009 11.25C16.5009 11.0508 16.4218 10.8598 16.281 10.719C16.1402 10.5782 15.9492 10.4991 15.75 10.4991C15.5508 10.4991 15.3598 10.5782 15.219 10.719L11.25 14.6895L9.531 12.969C9.39017 12.8282 9.19916 12.7491 9 12.7491C8.80084 12.7491 8.60983 12.8282 8.469 12.969C8.32817 13.1098 8.24905 13.3008 8.24905 13.5C8.24905 13.6992 8.32817 13.8902 8.469 14.031L10.719 16.281C10.7887 16.3508 10.8714 16.4063 10.9625 16.4441C11.0537 16.4819 11.1513 16.5013 11.25 16.5013C11.3487 16.5013 11.4463 16.4819 11.5375 16.4441C11.6286 16.4063 11.7113 16.3508 11.781 16.281L16.281 11.781Z" fill="white"/>
                <path d="M21 21V6.75L14.25 0H6C5.20435 0 4.44129 0.316071 3.87868 0.87868C3.31607 1.44129 3 2.20435 3 3V21C3 21.7956 3.31607 22.5587 3.87868 23.1213C4.44129 23.6839 5.20435 24 6 24H18C18.7956 24 19.5587 23.6839 20.1213 23.1213C20.6839 22.5587 21 21.7956 21 21ZM14.25 4.5C14.25 5.09674 14.4871 5.66903 14.909 6.09099C15.331 6.51295 15.9033 6.75 16.5 6.75H19.5V21C19.5 21.3978 19.342 21.7794 19.0607 22.0607C18.7794 22.342 18.3978 22.5 18 22.5H6C5.60218 22.5 5.22064 22.342 4.93934 22.0607C4.65804 21.7794 4.5 21.3978 4.5 21V3C4.5 2.60218 4.65804 2.22064 4.93934 1.93934C5.22064 1.65804 5.60218 1.5 6 1.5H14.25V4.5Z" fill="white"/>
                </svg>
              </a>
            </div>
          </nav>
        <nav
          class="sidebar-nav"
          v-else
        >
            <div
              class="nav-featured-area"
              :class="[accountNavFeaturedAreaClass]"
              :style="{ overflow: multiselectOpened ? 'visible' : 'hidden' }"
            >
              <div class="featured-name">
                <span
                  v-if="tenants && tenants.length"
                  v-b-tooltip.bottom="tenant.fullName"
                >
                  <Multiselect
                    label="name"
                    track-by="id"
                    placeholder="Selecionar"
                    v-model="selectedTenant"
                    :options="filteredTenants"
                    :allow-empty="false"
                    :show-labels="false"
                    @select="selectTenant"
                    @open="toggleMultiSelect(true)"
                    @close="toggleMultiSelect(false)"
                  >
                  <template slot="noResult">{{ __('Nenhum resultado encontrado') }}</template>
                  <template slot="singleLabel">{{ selectedTenant.name }}
                      <svg
                        class="ml-2"
                        xmlns="http://www.w3.org/2000/svg"
                        width="11"
                        height="11"
                        viewbox="0 0 11 11"
                      >
                        <g>
                          <g>
                            <g>
                              <path
                                fill="#f6f5f8"
                                d="M10.853 8.354a.5.5 0 0 0 0-.707l-2.5-2.5a.5.5 0 1 0-.707.707L9.292 7.5H.5a.5.5 0 0 0 0 1h8.792l-1.646 1.646a.5.5 0 1 0 .707.708z"
                              />
                            </g>
                            <g>
                              <path
                                fill="#f6f5f8"
                                d="M.146 3.354l2.5 2.5a.5.5 0 0 0 .707-.707L1.707 3.5H10.5a.5.5 0 0 0 0-1H1.707L3.353.854a.498.498 0 0 0 0-.707.5.5 0 0 0-.707 0l-2.5 2.5a.5.5 0 0 0 0 .707z"
                              />
                            </g>
                          </g>
                        </g>
                      </svg>
                  </template>
                </Multiselect></span><span
                class="cursor-default"
                v-else
              >{{ tenant.name }}</span><i
                  class="fa fa-chevron-up text-white"
                  v-if="featuredAreaLinks.conta"
                  @click="toggleAccountNavIsCollapsed"
                />
              </div>
            <div v-if="! accountNavIsCollapsed">
                <ul
                  class="nav no-bb p-0"
                  v-for="(links, index) in featuredAreaLinks"
                  :key="index"
                >
                  <li class="nav-title cursor-default">
                    {{ __(index) }}
                  </li>
                <li
                  class="nav-item"
                  v-for="(link, index) in links"
                  :key="index"
                >
                    <a
                      class="nav-link"
                      :href="link.href"
                      :class="{ active: isActive(link.active), locked: link.locked }"
                      @click="upgrade($event, link.locked)"
                    >
                    <IconPadlock
                      class="mb-1"
                      v-if="link.locked"
                    /> {{ link.name }}</a>
                  </li>
                </ul>
              </div>
            </div>
          <ul
            class="nav"
            v-for="(links, index) in sideBarLinks"
            :key="index"
          >
              <li class="nav-title">
                {{ __(index) }}
              </li>
            <li
              class="nav-item"
              v-for="(link, id) in links"
              :key="id"
            >
                <a
                  class="nav-link"
                  :href="link.href"
                  :class="{ active: isActive(link.active), locked: link.locked }"
                  @click="upgrade($event, link.locked)"
                >
                <IconPadlock
                  class="mb-1"
                  v-if="link.locked"
                /> {{ link.name }}</a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { VBTooltip } from 'bootstrap-vue';
import { Swal } from 'sweetalert2';

const FEATURED_AREA_LINKS = ['conta'];
const TENANT_NAME_MAX_LENGHT = 12;

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },

  props: {
    links: {
      required: true,
      type: Object,
    },

    path: {
      type: String,
      default: '',
    },

    tenant: {
      required: true,
      type: Object,
    },

    user: {
      required: true,
      type: Object,
    },

    tenants: {
      default: null,
    },

    root: {
      default: false,
      type: Boolean,
    },
  },

  data () {
    return {
      sidebarPosition: 'fixed',
      isCollapsed: false,
      keepCollapsed: false,
      accountNavIsCollapsed: true,
      selectedTenant: this.tenant,
      multiselectOpened: false,
      channel: null,
      timeouts: [],
      intervalId: null,
      hasError: false,
    };
  },

  created () {
    this.calculateSidebarPosition();

    window.addEventListener('resize', () => Vue.nextTick(() => this.calculateSidebarPosition()));

    this.listenBrowserBroadcastChannel();
    this.listenWebsocketBroadcastChannel();

    if (!!window.performance && window.performance.navigation.type === 2) {
      this.checkIfTenantIsUpToDate(true);
    }

    this.intervalId = setInterval(() => {
      this.checkIfTenantIsUpToDate();
    }, 3000);
  },

  mounted () {
    if (localStorage) {
      this.isCollapsed = localStorage.theSidebarIsCollapsed === 'true';
      // this.accountNavIsCollapsed = false;
    }

    this.truncateTenantName(this.selectedTenant);

    Bus.$on('collapseSidebar', (collapse) => this.isCollapsed = collapse);
  },

  watch: {
    isCollapsed (newValue) {
      localStorage.theSidebarIsCollapsed = newValue;
    },

    accountNavIsCollapsed (newValue) {
      localStorage.theSidebarAccountNavIsCollapsed = newValue;
    },
  },

  methods: {
    /**
     * Set position to sticky if height is smaller than 693
     */
    calculateSidebarPosition () {
      if (window.innerWidth < 1024) {
        return this.sidebarPosition = 'sticky';
      }

      const min = this.accountNavIsCollapsed ? 829 : 693;

      this.sidebarPosition = window.innerHeight < min ? 'sticky' : 'fixed';
    },

    handleKey (event) {
      console.log(event);
    },

    /**
     * Toggle the data property isCollapsed. If
     * value is true, will be changed to false and
     * if value is false, will be changed to true.
     *
     * @returns {void}
     */
    toggleIsCollapsed (keepCollapsed) {
      this.isCollapsed = ! this.isCollapsed;
      this.keepCollapsed = keepCollapsed === true;

      Bus.$emit('sidebarToggled', {isCollapsed: this.isCollapsed});
    },

    mouseLeftSidebar () {
      if (this.keepCollapsed) {
        this.isCollapsed = true;
      }

      if (! this.theSidebarIsCollapsed) {
        Bus.$emit('sidebarToggled', {isCollapsed: this.isCollapsed});
      }
    },

    /**
     * Toggle the data property accountNavIsCollapsed. If
     * value is true, will be changed to false and
     * if value is false, will be changed to true.
     *
     * @returns {void}
     */
    toggleAccountNavIsCollapsed () {
      this.accountNavIsCollapsed = ! this.accountNavIsCollapsed;

      this.calculateSidebarPosition();
    },

    async selectTenant (tenant) {
      this.truncateTenantName(tenant);

      try {
        await this.broadcastTenantChangedEvent(tenant.public_key, this.tenant.public_key);
      } catch (error) {
        // ignore
      }

      window.location.href = `/tenant/${tenant.public_key}/set`;
    },

    truncateTenantName (tenant) {
      tenant.fullName = tenant.name;

      tenant.name = tenant.name.length > TENANT_NAME_MAX_LENGHT
          ? `${tenant.name.substr(0, TENANT_NAME_MAX_LENGHT - 2)}...`
          : tenant.name;
    },

    toggleMultiSelect (open) {
      this.multiselectOpened = open;
    },

    isActive (regex) {
      return (new RegExp(regex)).test(this.path);
    },

    isIconActive (list) {
      for (const key in this.links[list]) {
        if (this.isActive(this.links[list][key].active)) {
          return true;
        }
      }

      return false;
    },

    listenWebsocketBroadcastChannel() {
      try {
        Echo.channel(`Bulldesk.User.Model.User.${this.user.id}`)
          .listen('.tenant_changed', (event) => {
            this.handleTenantChangedEvent({
              old_public_key: event.old,
              new_public_key: event.new,
            });
          });
      } catch (error) {
        console.error(error)
      }
    },

    listenBrowserBroadcastChannel() {
      try {
        if (!this.channel) {
          this.channel = new BroadcastChannel('tenant_changed');
        }

        this.channel.onmessage = (event) => {
          this.handleTenantChangedEvent(event.data)
        };
      } catch (error) {
        console.error(error)
      }
    },

    handleTenantChangedEvent(event) {
      if (this.tenant.public_key == event.new_public_key) {
        return;
      }

      this.timeouts.map((timeout) => clearTimeout(timeout));

      const timeout = setTimeout(() => {
        window.location.reload();
      }, 3000);

      this.timeouts.push(timeout);
    },

    broadcastTenantChangedEvent(new_public_key, old_public_key) {
      return new Promise((resolve, reject) => {
        try {
          if (!this.channel) {
            this.channel = new BroadcastChannel('tenant_changed');
          }

          this.channel.postMessage({ new_public_key, old_public_key });

          setTimeout(resolve, 100);
        } catch (error) {
          reject(error);
        }
      });
    },

    async getCurrenTenant() {
      if (this.hasError) return null;

      try {
        const { data: user } = await this.$http.get("/user/json/me", {
          headers: {
            Accept: "application/json",
          },
        });
        return user.tenant;
      } catch (error) {
        console.error("Error fetching tenant:", error);
        this.hasError = true;
        clearInterval(this.intervalId);
        return null;
      }
    },

    async checkIfTenantIsUpToDate(steal = false) {
      if (this.hasError) return;
      navigator.locks.request('check_tenant', { ifAvailable: !steal, steal }, async (lock) => {
          if (!lock) {
            return;
          }

          const tenant = await this.getCurrenTenant();

          if (tenant && tenant.public_key == this.tenant.public_key) {
            await this.sleep(30000);

            return;
          }

        await this.broadcastTenantChangedEvent(tenant.public_key, this.tenant.public_key)

          window.location.reload();
      });
    },

    sleep(milliseconds) {
      return new Promise((resolve) => setTimeout(resolve, milliseconds));
    },

    upgrade (event, locked = false) {
      if (locked) {
        event.preventDefault();

        Swal.fire({
          width: 480,
          html: `<div class="top">${this.__('Você não tem acesso')}.</div>`
              + `<div class="title">${this.__('Faça o upgrade<br>da sua conta')}.</div>`
              + '<div class="my-20px"><img src="/build/icons/prototype.png" alt="Protótipo"></div>'
              + `<div>${this.__('Fazendo o upgrade, você pode visualizar')}<br>`
              + `${this.__('esta e outras novas funcionalidades')}.</div>`
              + `<div class="f-w-700">${this.__('Faça agora mesmo')}.</div>`,
          buttonsStyling: false,
          confirmButtonClass: 'btn btn-primary',
          confirmButtonText: this.__('Upgrade da conta'),
          cancelButtonColor: 'transparent',
          cancelButtonText: this.__('Cancelar'),
          customClass: {
            container: 'container-swal2-upgrade',
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn swal2-btn-cancel-transparent swal2-btn-full-line',
          },
        }).then((result) => {
          if (result.value) {
            window.location = '/billing';
          }
        });
      }
    },
  },

  computed: {
    /**
     * The sidebar class.
     *
     * @returns {string}
     */
    sideBarClass () {
      return this.isCollapsed ? 'collapsed' : '';
    },

    /**
     * The class for nav featured area
     *
     * @returns {string}
     */
    accountNavFeaturedAreaClass () {
      return this.accountNavIsCollapsed ? 'collapsed' : '';
    },

    filteredTenants () {
      return this.tenants ? this.tenants.filter((tenant) => tenant.public_key != this.tenant.public_key).map((tenant) => {
              if (this.root) {
                tenant.name += ` (${tenant.id})`;
              }

              return tenant;
      }) : [];
    },

    featuredAreaLinks () {
      const featuredLinks = {};

      for (const key in this.links) {
        if (FEATURED_AREA_LINKS.includes(key)) {
          featuredLinks[key] = this.links[key];
        }
      }

      return featuredLinks;
    },

    sideBarLinks () {
      const sideBarLinks = {};

      for (const key in this.links) {
        if (! FEATURED_AREA_LINKS.includes(key)) {
          sideBarLinks[key] = this.links[key];
        }
      }

      return sideBarLinks;
    },
  },
};
</script>
